import React from "react";
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns";
import { PickerPanel, PickerPanelProps } from "rc-picker";
import { FC } from "react";
import { useStore } from "effector-react";
import { $currentLocale } from "../../store/shared/locales";

type Props = Omit<PickerPanelProps<Date>, "generateConfig" | "locale">;

const DateInline: FC<Props> = ({ ...props }) => {
  const { rcPickerLocale: locale } = useStore($currentLocale);

  return (
    <PickerPanel
      {...props}
      locale={locale}
      generateConfig={dateFnsGenerateConfig}
    />
  );
};

export default DateInline;
